export default __webpack_public_path__ + "static/media/power.b8cec090.png";